// TODO MAKE THIS A COMPONENT IN THE FUTURE
import { HighlightOffRounded, SearchOutlined } from "@mui/icons-material";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  List,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import * as React from "react";
import { useDebouncedCallback } from "use-debounce";
import { useArticles } from "../../hooks/useArticles";
import { useXoraiaValue } from "../../hooks/useXoraia";

const XSearch = () => {
  const [open, setOpen] = React.useState<boolean>(false);
  const [search, setSearch] = React.useState<string>("");
  const { articles } = useArticles({ limit: 8, articleName: search.trim() });
  const { imageComponent, Link, env } = useXoraiaValue();

  const debounced = useDebouncedCallback(
    // function
    (value: string) => {
      setSearch(value);
    },
    // delay in ms
    300
  );

  return (
    <React.Fragment>
      <Tooltip title="Recherche">
        <IconButton color="inherit" onClick={() => setOpen(true)}>
          <SearchOutlined sx={{ fontSize: "inherit" }} />
        </IconButton>
      </Tooltip>

      <Dialog
        onClose={() => setOpen(false)}
        open={open}
        fullWidth
        maxWidth="xl"
        PaperProps={{
          sx: {
            borderRadius: 3,
            height: "70vh",
          },
        }}
      >
        <DialogTitle
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
            display: "flex",
          }}
        >
          <span>Recherche</span>
          <IconButton
            size="large"
            color="inherit"
            onClick={() => setOpen(false)}
          >
            <HighlightOffRounded sx={{ fontSize: "inherit" }} />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            hiddenLabel
            variant="outlined"
            placeholder="Que Recherchez vous?"
            InputProps={{ endAdornment: <SearchOutlined /> }}
            autoFocus
            onChange={(e) => debounced(e.target.value)}
          />
          {articles.length === 0 && (
            <Typography sx={{ fontSize: 40, textAlign: "center", p: 3 }}>
              Aucun Résultat
            </Typography>
          )}
          <List
            disablePadding
            sx={{
              flex: 1,
              mt: 2,
              height: "calc(100% - 60px)",
              overflowY: "scroll",
              fontFamily: "inherit",
              "& .MuiListItem-container:not(:last-of-type)": {
                borderBottom: 1,
                borderBottomColor: "rgba(0, 0, 0, 0.12)",
              },
            }}
          >
            {articles.map(({ id, images, name, category }) => {
              return (
                <ListItemButton
                  disableGutters
                  LinkComponent={Link}
                  href={`/products/${id}`}
                  key={id}
                  alignItems="flex-start"
                >
                  {imageComponent && (
                    <ListItemAvatar
                      sx={{
                        width: "60px",
                        height: "70px",
                        position: "relative",
                      }}
                    >
                      {imageComponent(
                        {
                          src: images[0],
                          alt: name,
                          width: "60px",
                          height: "70px",
                        },
                        env ?? "prod",
                        {},
                        "article id"
                      )}
                    </ListItemAvatar>
                  )}
                  <ListItemText
                    sx={{ mx: 1 }}
                    primary={name}
                    primaryTypographyProps={{
                      sx: {
                        fontFamily: "inherit",
                        mb: 2,
                        lineHeight: "1em",
                        fontWeight: 600,
                      },
                    }}
                    secondary={category.name}
                  />
                </ListItemButton>
              );
            })}
          </List>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default XSearch;
